module.exports = __webpack_public_path__ + "img/header_logo.864340bd.png";